import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationAlertDialogComponent } from '../../../settings/components/confirmation-alert-dialog/confirmation-alert-dialog.component';

@Component({
    selector: 'side-sheet',
    templateUrl: './side-sheet.component.html',
    styleUrls: ['./side-sheet.component.scss'],
})
export class SideSheetComponent implements OnInit {
    isHierarchySaveBtnDisabled = false;

    @Output() mainCancelClick: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() mainSaveClick: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() sideSheetCancelClick: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() sideSheetSaveClick: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() sideSheetDeleteClick: EventEmitter<any> = new EventEmitter<any>();
    @Input() isSideSheetSaveBtnDisabled: boolean;
    @Input() isMainSaveBtnDisabled: boolean;
    @Input() isDeleteButtonHidden: boolean;
    @Input() sideSheetTitle: string;
    @Input() isEditDialogClose: boolean;
    @Input() isMainButtonSetHidden?: boolean = false;

    isMainSaveButtonClicked = false;
    isSideSheetSaveButtonClicked = false;

    constructor(public dialog: MatDialog) {}

    ngOnInit() {
        this.closeDialog();
        //this.isMainButtonSetHidden = false;
    }

    closeDialog() {
        //this.editHierarchy.nativeElement.style.visibility = 'hidden';
        this.isEditDialogClose = true;
    }

    mainCancelClicked() {
        this.closeDialog();
        this.mainCancelClick.emit(true);
    }

    sideSheetCancelClicked() {
        this.closeDialog();
        this.sideSheetCancelClick.emit(true);
    }

    mainSaveClicked() {
        this.isMainSaveButtonClicked = true;
        this.isSideSheetSaveButtonClicked = false;
        this.closeDialog();
        this.mainSaveClick.emit(this.isMainSaveButtonClicked);
    }

    sideSheetSaveClicked() {
        this.isMainSaveButtonClicked = false;
        this.isSideSheetSaveButtonClicked = true;
        this.sideSheetSaveClick.emit(this.isSideSheetSaveButtonClicked);
    }

    sideSheetDeleteClicked() {
        this.isMainSaveButtonClicked = false;
        this.isSideSheetSaveButtonClicked = false;

        const dialogRef = this.dialog.open(ConfirmationAlertDialogComponent, {
            id: 'alert-dialog',
            data: {
                title: 'Delete level?',
                message: 'Are you sure you want to delete this hierarchy level?',
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.sideSheetDeleteClick.emit(result);
            }
        });
    }
}
